export const routeNames = {
	games: "games",
	game: "game",
	results: "results",
	stats: "stats",
	history: "history",
	deleteGame: "deleteGame"
};